import * as React from "react";
import styled, { css } from "styled-components";
import _ from "lodash";

import { ProductStatus as ProductStatusTypes } from "src/core/products/api/products.api";

interface IProps {
  status?: ProductStatusTypes;
}

interface IStatusWrapper {
  status?: string;
}

const StatusWrapper = styled("span")<IStatusWrapper>`
  font-weight: ${({ theme }) => theme.fonts.weights.bold};
  text-transform: capitalize;
  ${({ status }) => StatusCss(status)};
`;

const DefaultCss = css`
  color: inherit;
`;

const ActiveCss = css`
  color: ${({ theme }) => theme.colors.success};
`;

const SuspendedCss = css`
  color: ${({ theme }) => theme.colors.warn};
`;

const DelistedCss = css`
  color: ${({ theme }) => theme.colors.error};
`;

// Gives the status the appropriate colour
const StatusCss = (status?: string) => {
  switch (status) {
    case ProductStatusTypes.Active:
      return ActiveCss;

    case ProductStatusTypes.Suspended:
      return SuspendedCss;

    case ProductStatusTypes.Delisted:
      return DelistedCss;

    default:
      return DefaultCss;
  }
};

/**
 * Gets the product status
 */
const ProductStatus = ({ status }: IProps) => {
  // Only return the status if one is given
  if (status) {
    return (
      <StatusWrapper status={status}>
        {_.capitalize(status)}
      </StatusWrapper>
    );
  }

  return (
    <StatusWrapper>
      -
    </StatusWrapper>
  );
};

export default ProductStatus;
